
define('text!templates/modules/calendar/animated-session/tags/edit/tag-edit-content.html',[],function () { return '<div class="panel-body tag-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div class="tag-edit-form"></div>\n\n</div>\n';});

